<template>
  <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
      wrapClassName="ant-modal-cust-warp"
      style="top:5%;height: 85%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" v-bind="layout" :model="model" :rules="validatorRules">
        <a-form-model-item label="号码分区名称" required prop="name">
          <a-input v-model="model.name" placeholder="请输入号码分区名称"/>
        </a-form-model-item>

        <!--        <a-form-model-item label="号码算法类型" required prop="algorithmType">-->
        <!--          <a-select-->
        <!--              v-model="model.algorithmType"-->
        <!--              placeholder="请选择算法类型"-->
        <!--              option-filter-prop="children">-->
        <!--            <a-select-option value="default">default</a-select-option>-->
        <!--          </a-select>-->
        <!--        </a-form-model-item>-->

        <a-form-model-item label="号码类型" required prop="type">
          <a-select
              v-model="model.type"
              placeholder="请选择号码类型"
              option-filter-prop="children"
              show-search
              allowClear>
            <a-select-option v-for="option in numberTypeOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="最小值" prop="valueMin">
          <a-input-number
              v-model="model.valueMin"
              placeholder="请输入最小值"
              :min="0"
              :max="999999999"
              style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item label="最大值" prop="valueMax">
          <a-input-number
              v-model="model.valueMax"
              placeholder="请输入最大值"
              :min="0"
              :max="999999999"
              style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item label="当前值" prop="currentValue">
          <a-input-number
              v-model="model.currentValue"
              placeholder="请输入当前值"
              :min="0"
              :max="999999999"
              :disabled="!!model.id"
              style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item label="号码前缀" prop="prefix">
          <a-input v-model="model.prefix" placeholder="请输入号码前缀"/>
        </a-form-model-item>

        <a-form-model-item label="号码后缀" prop="suffix">
          <a-input v-model="model.suffix" placeholder="请输入号码后缀"/>
        </a-form-model-item>

        <a-form-model-item label="数值长度" required prop="numberDigits">
          <a-input-number
              v-model="model.numberDigits"
              placeholder="请输入数值长度"
              :min="1"
              :max="20"
              style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item label="备注" prop="remark">
          <a-textarea
              v-model="model.remark"
              placeholder="请输入备注"
              :rows="3"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import {createNumberInterval, updateNumberInterval} from 'api/numberInterval'
import {mapGetters} from 'vuex'

export default {
  name: "NumberRuleCreater",
  computed: {
    ...mapGetters(["numberTypeOptions"]),
  },
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      layout: {
        labelCol: {span: 6},
        wrapperCol: {span: 14},
      },
      confirmLoading: false,
      validatorRules: {
        name: [
          {required: true, message: '请输入号码分区名称'},
        ],
        // algorithmType: [
        //   { required: true, message: '请选择算法类型'},
        // ],
        type: [
          {required: true, message: '请选择号码类型'},
        ],
        numberDigits: [
          {required: true, message: '请输入数值长度'},
        ],
        valueMin: [
          {type: 'number', message: '最小值必须为数字'},
        ],
        valueMax: [
          {type: 'number', message: '最大值必须为数字'},
        ],
        currentValue: [
          {type: 'number', message: '当前值必须为数字'},
        ]
      },
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
  },
  // mounted() {
  //   this.$store.dispatch('GetNumberTypeOptions');
  // },
  methods: {
    add() {
      this.edit({...this.modelDefault});
      this.title = '新增号码规则';
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.id) {
        this.title = '编辑号码规则';
      } else {
        this.title = '新增号码规则';
      }
    },
    close() {
      this.$refs.form.clearValidate();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          // 验证最小值不能大于最大值
          if (this.model.valueMin && this.model.valueMax && this.model.valueMin > this.model.valueMax) {
            this.$message.warning('最小值不能大于最大值');
            return false;
          }

          // 验证当前值在最小值和最大值之间
          if (this.model.currentValue) {
            if (this.model.valueMin && this.model.currentValue < this.model.valueMin) {
              this.$message.warning('当前值不能小于最小值');
              return false;
            }
            if (this.model.valueMax && this.model.currentValue > this.model.valueMax) {
              this.$message.warning('当前值不能大于最大值');
              return false;
            }
          }

          that.confirmLoading = true;

          // 构建请求参数，映射前端字段到后端字段
          const params = {
            id: this.model.id,
            name: this.model.name.trim(), // 号码分区名称 -> name
            valueMin: this.model.valueMin, // 最小值 -> valueMin
            valueMax: this.model.valueMax, // 最大值 -> valueMax
            prefix: this.model.prefix.trim(), // 号码前缀 -> prefix
            suffix: this.model.suffix.trim(), // 号码后缀 -> suffix
            numberDigits: this.model.numberDigits, // 数值长度 -> numberDigits
            // algorithmType: this.model.algorithmType, // 号码算法类型 -> algorithmType
            remark: this.model.remark, // 备注 -> remark
            type: this.model.type, // 号码类型 -> type
            version: this.model.version || 1 // 版本号
          };

          // 如果有当前值，添加到参数中
          if (this.model.currentValue !== undefined && this.model.currentValue !== null) {
            params.currentValue = this.model.currentValue;
          }

          // 调用相应的API
          const apiCall = this.model.id ? updateNumberInterval(params) : createNumberInterval(params);

          apiCall.then(res => {
            if (res.code == 200) {
              that.$message.success(that.model.id ? '编辑成功' : '新增成功');
              that.$emit('ok');
              that.close();
            } else {
              that.$message.error(res.msg || '操作失败');
            }
          }).catch(error => {
            console.error('API调用失败:', error);
            that.$message.error('操作失败，请稍后重试');
          }).finally(() => {
            that.confirmLoading = false;
          });
        } else {
          return false;
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
